import React, { Component } from "react";
import "./LegacyMenu.scss";
import Collapsible from "react-collapsible";
import { NavLink } from "react-router-dom";
// import { setChartsTabIndex } from "../../../actions/csApiAction";
// import { AutoPushCall } from "../../../actions/rawDataAction";
// import { setAppliedFitler, updateSelectedFilterIndex, updateCurrentView } from "../../../actions/globalAction";
// import { fetchRawData } from "../../../actions/rawDataAction";
// import { fetchChartsDataUnified } from "../../../actions/csApiAction";
// import { connect } from "react-redux";
import { menuList, settingsMenu, menuLinks, smrWithSettings, smrWithoutSettings, subscriptionSettings, smrWithSettingswithoutAnalytics } from "./menuUtils";

// Menu Icons
import { ReactComponent as adminpanel } from "../../../assets/svg/adminpanel.svg";
import { ReactComponent as video } from "../../../assets/svg/video-tutorials.svg";
import { ReactComponent as alert } from "../../../assets/svg/alert.svg";
import { ReactComponent as collection } from "../../../assets/svg/collection.svg";
import { ReactComponent as dashboard } from "../../../assets/svg/dashboard.svg";
import { ReactComponent as datausage } from "../../../assets/svg/datausage-old.svg";
import { ReactComponent as ownedpageanalytics } from "../../../assets/svg/ownedpageanalytics.svg";
import { ReactComponent as facebookInsights } from "../../../assets/svg/facebook-insight.svg";
import { ReactComponent as query } from "../../../assets/svg/query.svg";
import { ReactComponent as report } from "../../../assets/svg/report.svg";
import { ReactComponent as socialtokens } from "../../../assets/svg/socialtokens.svg";
import { ReactComponent as trend } from "../../../assets/svg/trend.svg";
import { ReactComponent as usermanagement } from "../../../assets/svg/usermanagement.svg";
import { ReactComponent as privateviews } from "../../../assets/svg/privateviews.svg";
import { ReactComponent as publicviews } from "../../../assets/svg/publicviews.svg";
import { ReactComponent as teamviews } from "../../../assets/svg/teamviews.svg";
import { ReactComponent as systemviews } from "../../../assets/svg/systemviews.svg";
import { ReactComponent as search } from "../../../assets/svg/search.svg";
import { ReactComponent as scanner } from "../../../assets/svg/scanner.svg";
import { ReactComponent as downloads } from "../../../assets/svg/downloads.svg";
import { ReactComponent as settings } from "../../../assets/svg/settings.svg";
import { ReactComponent as commandcenter } from "../../../assets/svg/command-center.svg";
import { ReactComponent as Chevron } from "../../../assets/svg/chevron.svg";
import { ReactComponent as data } from "../../../assets/svg/querybuilder.svg";
import { ReactComponent as privacypolicy } from "../../../assets/svg/privacypolicy.svg";
import { ReactComponent as research } from "../../../assets/svg/research.svg";
import { ReactComponent as ErrImage } from "../../../assets/svg/radarr-logo.svg";
import { ReactComponent as smr } from "../../../assets/svg/smr-icon.svg";
import { ReactComponent as subscription } from "../../../assets/svg/subscription-icon.svg";
import { ReactComponent as home } from "../../../assets/svg/Home.svg";
import { gettingStartedProgress } from "../../../actions/globalAction";
import { connect } from "react-redux";
import { mapStateToProps } from "../../MainContent/queryBuilder/components/viewQuery/ViewQuery";

const menuIcons = {
    adminpanel,
    alert,
    home,
    collection,
    dashboard,
    datausage,
    ownedpageanalytics,
    query,
    report,
    socialtokens,
    trend,
    usermanagement,
    privateviews,
    publicviews,
    teamviews,
    systemviews,
    search,
    scanner,
    downloads,
    video,
    // empty,
    facebookInsights,
    settings,
    commandcenter,
    data,
    privacypolicy,
    research,
    smr,
    subscription,
};

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            level1: "",
            level2: "",
            // menuItems: this.props.menuItems,
            systemViews: [],
            privateViews: [],
            publicViews: [],
            teamViews: [],
            blockOne: [],
            blockTwo: [],
            blockThree: [],
            isError: false,
            percentage: "",
        };

        this.tokenProviderType = this.props.user?.roles.length === 1 && this.props.user?.roles?.includes("token_provider");
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pathname != this.props.pathname) {
            this.updateSidebarHighlights();
        }

        if (prevProps.company.company_logo_v2 != this.props.company.company_logo_v2) {
            // this.updateSidebarHighlights();
            this.setState({
                isError: false,
            });
        }
    }

    componentDidMount() {
        this.updateSidebarHighlights();
        // this.getViewItems();
    }

    updateSidebarHighlights = () => {
        let pathvals = this.props.pathname.split("/");
        // console.log(this.props.pathname, pathvals);
        if (menuLinks.includes(pathvals[1])) {
            if (["facebook-tokens", "instagram-tokens"].includes(pathvals[1])) {
                this.setState({ level1: "ADD SOCIAL TOKENS", level2: "" });
            } else if (["settings"].includes(pathvals[1])) {
                this.setState({ level1: "SETTINGS", level2: "" });
            } else if (["twitter-trends", "youtube-trends"].includes(pathvals[1])) {
                this.setState({ level1: "TRENDS", level2: "" });
            } else if (["dashboard"].includes(pathvals[1])) {
                this.setState({ level1: "Dashboard", level2: "" });
            } else if (["billing"].includes(pathvals[1]) && !["history"].includes(pathvals[1])) {
                this.setState({ level1: "Subscription", level2: "" });
            } else if (["social-response"].includes(pathvals[1])) {
                this.setState({ level1: "Social Media Response", level2: "" });
            }
        } else {
            this.setState({ level1: "", level2: "" });
        }
    };

    isPartOfteam(values) {
        if (!values) {
            return true;
        }
        values = values.split(",");
        let isPart = false;
        let i;
        for (i = 0; i < this.props.teams.length; i++) {
            if (values.includes(this.props.teams[i].value)) {
                isPart = true;
                break;
            }
        }
        return isPart;
    }

    getBlockOne() {
        let menu = [];
        let percent = 0;
        if (
            this.props.user.roles.includes("admin") ||
            this.props.user.roles.includes("cxm") ||
            this.props.user.roles.includes("companyadmin") ||
            this.props.user.roles.includes("cxa")
        ) {
            if (this.props.user.roles.includes("admin") || this.props.user.roles.includes("cxm") || this.props.user.roles.includes("companyadmin")) {
                if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                    percent = Math.round((this.props.progressFields?.sections?.length / 10) * 100);
                else percent = Math.round((this.props.progressFields?.sections?.length / 11) * 100);
            } else {
                if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                    percent = Math.round((this.props.progressFields?.sections?.length / 9) * 100);
                else percent = Math.round((this.props.progressFields?.sections?.length / 10) * 100);
            }
        } else {
            if (this.props.packageObj?.features?.owned_page_analytics.quota == 0) percent = Math.round((this.props.progressFields?.sections?.length / 8) * 100);
            else percent = Math.round((this.props.progressFields?.sections?.length / 9) * 100);
        }
        // console.log("percent", percent);

        //Getting Started
        if (this.props.showGettingStarted && percent !== 100) menu.push(this.getItem(menuList.find((m) => m.name === "Getting Started")));

        //QueryBuilder
        // if (this.props.packageObj?.features?.owned_page_analytics.quota > 0)
        menu.push(this.getItem(menuList.find((m) => m?.key === "Query Builder")));
        // else menu.push(this.getItem(menuList.find((m) => m?.key === "Query Builder Trial")));

        // dashboard
        menu.push(this.getItem(menuList.find((m) => m.name === "Dashboard")));

        // trends
        menu.push(this.getItem(menuList.find((m) => m.name === "TRENDS")));

        // Reports
        menu.push(this.getItem(menuList.find((m) => m.name === "REPORTS")));

        // Alerts
        menu.push(this.getItem(menuList.find((m) => m.name === "ALERTS")));

        // collaborate
        menu.push(this.getItem(menuList.find((m) => m.name === "COLLECTIONS")));

        // Facebook insights
        if (this.props.packageObj?.features?.owned_page_analytics.quota > 0) menu.push(this.getItem(menuList.find((m) => m.name === "PAGE ANALYTICS")));

        //social response
        if (this.props.company.smr_enabled === 1) {
            if (
                this.props.user.roles.includes("admin") ||
                this.props.user.roles.includes("cxm") ||
                this.props.user.roles.includes("companyadmin") ||
                this.props.user.roles.includes("cxa")
            ) {
                if (this.props.user.roles.includes("companyadmin") || this.props.user.roles.includes("admin") || this.props.user.roles.includes("cxm")) {
                    if (this.props.user.roles.includes("cxm")) menu.push(this.getItem(smrWithSettings));
                    else menu.push(this.getItem(smrWithSettingswithoutAnalytics));
                } else {
                    menu.push(this.getItem(smrWithoutSettings));
                }
            }
        }
        //(this.props.company.user_type !== "admin")
        // DOWNLOADS
        menu.push(this.getItem(menuList.find((m) => m.name === "DOWNLOADS")));

        //Search
        menu.push(this.getItem(menuList.find((m) => m.name === "Search")));
        menu.push(this.getItem(menuList.find((m) => m.name === "Tutorials")));

        // beacon
        // menu.push(this.getItem(menuList.find((m) => m.name === "BEACON")));

        return menu;
    }

    // getBlockTwo = () => {
    //     let menu = [];

    //     // Search
    //     menu.push(this.getItem(menuList.find((m) => m.name === "SEARCH")));

    //     // System views
    //     if (this.state.systemViews.length > 0)
    //         menu.push(
    //             this.getItem({
    //                 name: "SYSTEM VIEWS",
    //                 subItems: this.state.systemViews,
    //                 icon: "systemviews",
    //             }),
    //         );

    //     // Private views
    //     if (this.state.privateViews.length > 0)
    //         menu.push(
    //             this.getItem({
    //                 name: "PRIVATE VIEWS",
    //                 subItems: this.state.privateViews,
    //                 icon: "privateviews",
    //             }),
    //         );

    //     // Public views
    //     if (this.state.publicViews.length > 0)
    //         menu.push(
    //             this.getItem({
    //                 name: "PUBLIC VIEWS",
    //                 subItems: this.state.publicViews,
    //                 icon: "publicviews",
    //             }),
    //         );

    //     // Team views
    //     if (this.state.teamViews.length > 0)
    //         menu.push(
    //             this.getItem({
    //                 name: "TEAM VIEWS",
    //                 subItems: this.state.teamViews,
    //                 icon: "teamviews",
    //             }),
    //         );

    //     return menu;
    // };

    getBlockThree = () => {
        let menu = [];

        // DATA USAGE

        if (!this.tokenProviderType && this.props.packageObj?.package_code !== "free") menu.push(this.getItem(menuList.find((m) => m.name === "DATA USAGE")));

        // ADD SOCIAL TOKENS
        menu.push(this.getItem(menuList.find((m) => m.name === "SOCIAL TOKENS")));

        return menu;
    };

    getSubscriptionBlock = () => {
        let menu = [];
        //Subscriptions

        menu.push(this.getItem(subscriptionSettings));

        return menu;
    };

    onError = () => {
        this.setState({
            isError: true,
        });
    };

    handleCollapsibleClick(item) {
        if (!this.props.sidebarExpanded) this.props.sidebarToggle();
        else if (item.name === this.state.level1 || item.name === this.state.level2) {
            return this.setState({ level1: "", level2: "" });
        }

        if (item.level === 1) {
            this.setState({ level1: item.name });
        }

        if (item.level === 2) {
            this.setState({
                level1:
                    item.view_type === "system"
                        ? "SYSTEM VIEWS"
                        : parseInt(item.access_type) === 0
                        ? "PRIVATE VIEWS"
                        : parseInt(item.access_type) === 1
                        ? "PUBLIC VIEWS"
                        : "TEAM VIEWS",
                level2: item.name,
            });
        }
    }

    handleLinkClick = (item) => {
        // console.log("...item...", item);
        if (item.name == "Getting Started") this.props.gettingStartedProgress();
        if (item.level === 1) this.setState({ level1: "", level2: "" });

        if (
            item.name == "All Dashboards" ||
            item.name == "Standard Dashboards" ||
            item.name == "My Dashboards" ||
            item.name == "Shared Dashboards" ||
            item.name == "Favorites"
        ) {
            localStorage.removeItem("tour_createDashboard"); //to restart dashboard tour
        }
    };

    toTitleCase = (str) => {
        if (str === "YouTube Trends") return "YouTube Trends";
        if (str === "SMR Settings") return "SMR Settings";
        if (str === "SMR Analytics") return "SMR Analytics";
        if (str === "SMR Inbox") return "SMR Inbox";
        if (str === "SMR Canned Response") return "SMR Canned Response";
        if (str === "SMR Integrations") return "SMR Integrations";
        if (str === "Integrations") return "Integrations";
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    getItem(item, level = 1) {
        // console.log("dssddsdssd", item);
        let tour_className = "";
        if (item.name == "TRENDS") tour_className = "trends_step1";
        if (item.name == "X Trends") tour_className = "trends_step2";
        if (item.name == "YouTube Trends") tour_className = "trends_step3";
        if (item.name == "Dashboard") tour_className = "dashboard_step1";
        if (item.name == "All Dashboards") tour_className = "dashboard_step2";
        if (item.name == "Standard Dashboards") tour_className = "dashboard_step3";
        if (item.name == "My Dashboards") tour_className = "dashboard_step4";
        if (item.name == "Shared Dashboards") tour_className = "dashboard_step5";
        if (item.name == "Favorites") tour_className = "dashboard_step6";
        if (item.name == "Trash") tour_className = "dashboard_stepTrash";
        if (item.name == "REPORTS") tour_className = "reports_step1";
        if (item.name == "ALERTS") tour_className = "alerts_step1";
        if (item.name == "COLLECTIONS") tour_className = "collection_step0";
        if (item.name == "FACEBOOK") tour_className = "fbInsights_step0";
        if (item.name == "DOWNLOADS") tour_className = "downloads_step0";
        if (item.name == "Search") tour_className = "search_step0";
        if (item.name == "DATA USAGE") tour_className = "dataUsage_step0";
        if (item.name == "ADD SOCIAL TOKENS") tour_className = "fbTokens_step0";
        if (item.name == "Facebook Tokens") tour_className = "fbTokens_step1";
        if (item.name == "Instagram Tokens") tour_className = "igTokens_step1";
        if (item.name == "BLOCK SOURCE") tour_className = "blockSource_step0";
        if (item.name == "FILTERS") tour_className = "filters_step1";
        if (item.name == "WORDCLOUD") tour_className = "wordCloud_step1";
        if (item.name == "USER MANAGEMENT") tour_className = "userManagement_step1";
        if (item.name == "LOGIN LOGS") tour_className = "loginLogs_step0";
        if (item.name == "Logo") tour_className = "logo_step0";
        if (item.name == "Social Media Response") tour_className = "smr_step0";
        if (item.name == "SMR Settings") tour_className = "smr_step1";
        if (item.name == "Smart Inbox" || item.name == "Social Media Response") tour_className = "smr_step11";
        if (item.name == "SMR Analytics") tour_className = "smr_step14";
        // if (item.name == "Query Builder") tour_className = "qb_step1";

        let percentage = "";
        if (item.name == "Getting Started") {
            let percent = 0;
            if (
                this.props.user.roles.includes("admin") ||
                this.props.user.roles.includes("cxm") ||
                this.props.user.roles.includes("companyadmin") ||
                this.props.user.roles.includes("cxa")
            ) {
                if (this.props.user.roles.includes("admin") || this.props.user.roles.includes("cxm") || this.props.user.roles.includes("companyadmin")) {
                    if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                        percent = Math.round((this.props.progressFields?.sections?.length / 10) * 100);
                    else percent = Math.round((this.props.progressFields?.sections?.length / 11) * 100);
                } else {
                    if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                        percent = Math.round((this.props.progressFields?.sections?.length / 9) * 100);
                    else percent = Math.round((this.props.progressFields?.sections?.length / 10) * 100);
                }
            } else {
                if (this.props.packageObj?.features?.owned_page_analytics.quota == 0)
                    percent = Math.round((this.props.progressFields?.sections?.length / 8) * 100);
                else percent = Math.round((this.props.progressFields?.sections?.length / 9) * 100);
            }
            percentage = `(${percent}%)`;
        }

        if (item.subItems) {
            let IconComponent = menuIcons[item.icon];
            return (
                <Collapsible
                    open={this.props.sidebarExpanded && ((level === 1 && this.state.level1 === item.name) || (level === 2 && this.state.level2 === item.name))}
                    key={item.name}
                    id={item.name}
                    transitionTime={200}
                    handleTriggerClick={() => this.handleCollapsibleClick({ ...item, level })}
                    className={`level-${level}`}
                    openedClassName={`level-${level}`}
                    trigger={
                        <div title={item.name} className="collapsible-item" id={`collapsible-item ${item.name}`}>
                            <span className={`itemName ${tour_className}`}>
                                {level === 1 &&
                                    (IconComponent ? <IconComponent className={`item-icon ${item.icon}`} /> : <span className="image-placeholder"></span>)}
                                <span className="item-name-text">{this.toTitleCase(item.name)}</span>
                            </span>
                            <Chevron className="chevron-collapsible" />
                        </div>
                    }>
                    {this.props.sidebarExpanded && item.subItems.map((si) => this.getItem(si, level + 1))}
                </Collapsible>
            );
        } else {
            if (Object.prototype.hasOwnProperty.call(item, "type") && item.type === "react") {
                let IconComponent = menuIcons[item.icon];
                if (item.packageFeature && !item.packageFeature.includes(this.props.packageObj.package_code)) {
                    return;
                }
                return (
                    <NavLink
                        key={item.name + level}
                        style={{ textDecorationLine: "none", textDecoration: "none" }}
                        to={item.Link}
                        activeClassName="active"
                        onClick={() => this.handleLinkClick({ ...item, level })}>
                        <div
                            key={item.name}
                            title={item.name}
                            className={`menulink level-${level} ${
                                item.name.toLowerCase() === "custom dashboard" ? "custom-dashboard" : item.name.toLowerCase()
                            } `}>
                            <span className={`itemName ${tour_className}`}>
                                {level === 1 &&
                                    (item.icon ? <IconComponent className={`item-icon ${item.icon}`} /> : <span className="image-placeholder"></span>)}
                                <span className="item-name-text">
                                    {this.toTitleCase(item.name)} {percentage}
                                </span>
                            </span>
                        </div>
                    </NavLink>
                );
            } else {
                let IconComponent = menuIcons[item.icon];
                return (
                    <a
                        style={{ textDecorationLine: "none", textDecoration: "none" }}
                        href={this.gotoLink(item.Link)}
                        target={item.target ? item.target : "_self"}>
                        <div key={item.name} title={item.name} className={`menulink level-${level}`} onClick={() => this.gotoLink(item.Link)}>
                            <span className={`itemName ${tour_className}`}>
                                {level === 1 &&
                                    (item.icon ? <IconComponent className={`item-icon ${item.icon}`} /> : <span className="image-placeholder"></span>)}
                                <span className="item-name-text">{this.toTitleCase(item.name)}</span>
                            </span>
                        </div>
                    </a>
                );
            }
        }
    }

    gotoLink(link) {
        if (link) {
            if (process.env.NODE_ENV === "development") {
                if (link.indexOf("unified/") > -1) return link.split("unified/")[1];
                return link;
            } else if (link.indexOf("https://") > -1) return link;
            else return `/${link}`;
        }
    }

    render() {
        let companyLogo = this.props.company.company_logo_v2;
        let adminType = this.props.user?.roles?.includes("admin") || this.props?.user?.roles.includes("companyadmin");

        if (!companyLogo || !companyLogo.includes("https://")) companyLogo = this.props.company.company_logo;

        return (
            <div id="sidebarMenu" className="sidebarMenu">
                <div className="home_step5">
                    {!this.tokenProviderType && this.getBlockOne()}
                    {!this.tokenProviderType && <div className="sidebar-divider"></div>}
                    {this.getBlockThree()}
                    {!this.tokenProviderType && adminType && this.getItem(settingsMenu)}
                    {!this.tokenProviderType && this.props.packageObj?.package_code !== "enterprise" && this.getItem(subscriptionSettings)}
                    {/* <div className="sidebar-divider"></div>
                {this.getBlockTwo()} */}
                    <div className="sidebar-divider"></div>
                    {
                        !this.tokenProviderType && this.props.command_center && this.props.command_center.enabled
                        // this.getItem({ name: "Command Center", Link: "https://commandcenter.circussocial.com/", target: "_blank", icon: "commandcenter" }, 1)
                    }
                    {this.getItem({ name: "Privacy Policy", Link: "https://www.radarr.com/privacypolicy/", target: "_blank", icon: "privacypolicy" }, 1)}
                </div>
                {this.props.sidebarExpanded && (
                    <div className="company-logo">
                        {!this.state.isError ? <img src={companyLogo} className="company image" onError={this.onError} /> : <ErrImage />}
                    </div>
                )}
            </div>
        );
    }
}

// export default connect(null, {
//     // setAppliedFitler,
//     fetchRawData,
//     // fetchChartsDataUnified,
//     // updateSelectedFilterIndex,
//     // updateCurrentView,
//     // setChartsTabIndex,
//     AutoPushCall,
// })(Menu);

const mapStateToProps2 = (state) => {
    return {
        progressFields: state.globalReducer.progressFields,
        showGettingStarted: state.globalReducer.showGettingStarted,
        packageObj: state.globalReducer.packageObj,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
    };
};

export default connect(mapStateToProps2, mapDispatchToProps)(Menu);
